import { Typography } from "@mui/material"
import Alert from "@mui/material/Alert"
import Snackbar from "@mui/material/Snackbar"
import { getStore } from "app/store/store"
import { IAppMessage } from "message/model"
import { messageActionCreator } from "message/store/action"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

export interface IMessageProps {
  message: IAppMessage
}

export const AppMessage = React.memo(({ message }: IMessageProps) => {
  const { id, text, duration, severity } = message
  const onClose = () => getStore().dispatch(messageActionCreator.deleteMessage(id, true))
  return (
    <Snackbar
      key={id}
      sx={{
        position: "relative",
        pointerEvents: "all",
        marginTop: ".5rem"
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      ClickAwayListenerProps={{ mouseEvent: false }}
      open={true}
      onClose={() => onClose()}
      autoHideDuration={duration}>
      <Alert
        sx={{
          "width": "calc(100% - 1rem)",
          "minWidth": "calc(100% - 1rem)",
          "maxWidth": "calc(100% - 1rem)",
          "@media (min-width: 600px)": {
            width: "calc(100% - 3rem)",
            minWidth: "calc(100% - 3rem)",
            maxWidth: "calc(100% - 3rem)"
          }
        }}
        onClose={() => onClose()}
        variant="filled"
        severity={severity}>
        {Array.isArray(text) ? (
          <FlexBox vertical gap=".6rem" jc="flex-start" ai="flex-start">
            {text.map((t, index) => (
              <Typography key={index}>{t}</Typography>
            ))}
          </FlexBox>
        ) : (
          <Typography>{text}</Typography>
        )}
      </Alert>
    </Snackbar>
  )
})
